import { ClientConfigDto } from 'src/app/services/api.services';
import { environment } from './environments/environment';

export let clientConfig: ClientConfigDto = {
  authority: '',
  clientId: '',
  scope: '',
  deploymentInfo: {
    environmentName: environment.production ? 'Undefined' : 'LocalDev',
    releaseId: 'Undefined'
  }
};

export function setClientConfig(value: ClientConfigDto) {
  clientConfig = value;
}

export function isDevEnvironment() {
  return isLocalDevEnvironment()
    || clientConfig?.deploymentInfo?.environmentName.startsWith('Dev');
}

export function isLocalDevEnvironment() {
  return clientConfig?.deploymentInfo?.environmentName.startsWith('LocalDev');
}
